
import React from 'react'

const ShimmerLoader = ({label = "Loading content..."}) => {
    return (
        <div className="is-loading">
            <div className="loadable">{label}</div>
        </div>
    )
}

export default ShimmerLoader
